import React from 'react'
import PropTypes from 'prop-types'
import { slugify, candidateImgSrc, useDefaultImg } from '../../util'
import { NAMESPACED_IMAGES_FROM } from '../../config'

// Renders a candidate's headshot <img>, choosing the filename key and the
// per-election vs. flat directory. This is the single source of truth for how a
// candidate maps to an image file — reuse it instead of building the src inline
// (see the @todo notes in Race/PresidentNational/PresidentialPrimary*).
//
//  - Namespaced elections (date >= NAMESPACED_IMAGES_FROM): key by the AP polid,
//    or the AP candidateId for local candidates that have no polid. candidateImgSrc
//    routes these to the per-election folder (candidates/{date}/).
//  - Older elections: legacy flat dir — polid during a primary, else the name slug.
//
// Missing files fall back to default.jpg via onError.
const CandidateImage = ({ candidate, date, isPrimary, hasImages }) => {
  if (!hasImages) return null

  const namespaced = date >= NAMESPACED_IMAGES_FROM
  let key
  let className
  if (namespaced) {
    // AP candidates use polid (no extra class, matching the old polid path);
    // local candidates use candidateId and keep the results_tag_img styling.
    key = candidate.polid || candidate.candidateId
    if (!candidate.polid) className = 'results_tag_img'
  } else if (isPrimary && candidate.polid) {
    key = candidate.polid
  } else {
    key = slugify(candidate.name)
    className = 'results_tag_img'
  }

  return (
    <img
      src={candidateImgSrc(key, date)}
      alt={candidate.name}
      className={className}
      onError={useDefaultImg}
    />
  )
}

CandidateImage.propTypes = {
  candidate: PropTypes.object.isRequired,
  date: PropTypes.string,
  isPrimary: PropTypes.bool,
  hasImages: PropTypes.bool,
}

export default CandidateImage
